<ng-container *ngIf="dropdownType === 'simple'; else classicDropdown">
	<div class="dropdown icon-dropdown" ngbDropdown>
		<button class="btn dropdown-toggle" type="button" ngbDropdownToggle>
			<i class="icon-more-alt"></i>
		</button>
		<div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
			<a
				*ngFor="let option of options"
				class="dropdown-item"
				href="javascript:void(0)"
				(click)="selectItem(option.title)"
				ngbDropdownItem
			>
				{{ option.title }}
			</a>
		</div>
	</div>
</ng-container>

<ng-template #classicDropdown>
	<div class="dropdown" [ngClass]="dropdownClass" ngbDropdown>
		<button class="btn dropdown-toggle" type="button" ngbDropdownToggle>{{ selectedItem }}</button>
		<ul class="dropdown-menu" ngbDropdownMenu>
			<li *ngFor="let option of options" ngbDropdownItem>
				<a class="dropdown-item" href="javascript:void(0)" (click)="selectItem(option.title)">
					{{ option.title }}
				</a>
			</li>
		</ul>
	</div>
</ng-template>
